import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Loading from 'xpi-black-ui/Base/Loading';

import { ClientWrapper } from './styles';
import ClientsTable from './table';

const Clients = ({
  clients,
  hasError,
  errors,
  isRubiYield,
  loteMinimo,
  loadingClients,
  favoriteClient,
  onSelectClient,
  onReLoadClient,
  sendingProposal,
  precoReferencia,
  updateClientState,
}) => {
  const updateClients = (selectedClient, handler) => {
    const updatedClients = clients.map(client => (
      client.clienteId === selectedClient.clienteId ? handler(client) : client
    ));
    updateClientState(updatedClients);
  };

  return (
    <ClientWrapper>
      {sendingProposal && <Loading fixed text="Enviando proposta..." />}
      {loadingClients && <Loading fixed text="Carregando lista de clientes..." />}
      <ClientsTable
        clients={clients}
        hasError={hasError}
        errors={errors}
        isRubiYield={isRubiYield}
        loteMinimo={loteMinimo}
        updateClients={updateClients}
        favoriteClient={favoriteClient}
        onSelectClient={onSelectClient}
        onReLoadClient={onReLoadClient}
        precoReferencia={precoReferencia}
        updateClientState={updateClientState}
      />
    </ClientWrapper>
  );
}

Clients.propTypes = {
  clients: PropTypes.arrayOf(PropTypes.object),
};


export default Clients;
